import {
  AffineCanvasTextFonts,
  FontConfigExtension,
} from '@blocksuite/affine/blocks';

export function getFontConfigExtension() {
  return FontConfigExtension(
    AffineCanvasTextFonts.map(font => ({
      ...font,
      // self-hosted fonts are served from /assets
      url: '/assets/' + new URL(font.url).pathname.split('/').pop(),
    }))
  );
}
